/* eslint-disable max-len */
/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';

import {
    updateBillingAddressId,
    updateBillingSameAsShipping,
    updatePaymentMethodCode
} from '../store/CheckoutFields/CheckoutFields.action';

const propTypes = (member) => ({
    ...member,
    updatePaymentMethodCode: PropTypes.func.isRequired,
    updateBillingSameAsShipping: PropTypes.func.isRequired,
    updateBillingAddressId: PropTypes.func.isRequired,
    paymentMethodCode: PropTypes.string.isRequired,
    billingSameAsShipping: PropTypes.bool.isRequired,
    billingAddressId: PropTypes.number.isRequired
});

const setBillingMethodCodeInReducer = (args, callback, instance) => {
    const code = args?.[0] || '';
    const { updatePaymentMethodCode } = instance.props;

    updatePaymentMethodCode(code);

    callback(...args);
};

const onSameAsShippingChange = (args, callback, instance) => {
    const { updateBillingSameAsShipping } = instance.props;
    const { isSameAsShipping } = instance.state;

    updateBillingSameAsShipping(!isSameAsShipping);

    callback(...args);
};

const onAddressSelect = (args, callback, instance) => {
    const { updateBillingAddressId } = instance.props;
    const addressId = args?.[0] || 0;

    updateBillingAddressId(addressId);

    callback(...args);
};

const setPaymentMethodFromReducer = (args, callback) => {
    const { paymentMethodCode, paymentMethods } = args[0];
    const { paymentMethod } = args[1];

    if (paymentMethods?.length && paymentMethod === '') {
        return {
            paymentMethod: paymentMethodCode
        };
    }

    return callback(...args);
};

const mapDispatchToProps = (args, callback, _instance) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        updatePaymentMethodCode: (value) => dispatch(updatePaymentMethodCode(value)),
        updateBillingSameAsShipping: (value) => dispatch(updateBillingSameAsShipping(value)),
        updateBillingAddressId: (value) => dispatch(updateBillingAddressId(value))
    };
};

const mapStateToProps = (args, callback, _instance) => {
    const [state] = args;

    return {
        ...callback(...args),
        paymentMethodCode: state.CheckoutFieldsReducer.paymentMethodCode,
        billingSameAsShipping: state.CheckoutFieldsReducer.billingSameAsShipping,
        billingAddressId: state.CheckoutFieldsReducer.billingAddressId
    };
};

const useDefaultDataFromReducer = (args, callback, instance) => {
    callback(...args);
    const {
        billingSameAsShipping,
        billingAddressId
    } = instance.props;

    // eslint-disable-next-line no-param-reassign
    instance.state = {
        ...instance.state,
        isSameAsShipping: billingSameAsShipping,
        selectedCustomerAddressId: billingAddressId
    };
};

export default {
    'Component/CheckoutShipping/Container': {
        'static-member': {
            propTypes,
            getDerivedStateFromProps: setPaymentMethodFromReducer
        },
        'member-function': {
            __construct: useDefaultDataFromReducer,
            onPaymentMethodSelect: setBillingMethodCodeInReducer,
            onSameAsShippingChange,
            onAddressSelect
        }
    },
    'Component/CheckoutShipping/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    },
    'Component/CheckoutShipping/Container/mapStateToProps': {
        function: mapStateToProps
    }
};
